function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

/* icon/Display 32px/Chiropractic.svg: width 32px x height 32px */
var DlsIconChiropractic =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(DlsIconChiropractic, _CustomElement2);

  function DlsIconChiropractic() {
    _classCallCheck(this, DlsIconChiropractic);

    return _possibleConstructorReturn(this, _getPrototypeOf(DlsIconChiropractic).apply(this, arguments));
  }

  _createClass(DlsIconChiropractic, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" fill=\"none\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 32 32\"><path stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M30.99 22.083l-2.44-4.584a4.485 4.485 0 00-3.958-2.377h-5.769v-3.21c0-.366.298-.663.665-.663h1.03a.836.836 0 00.836-.836v-1.57l.807-.484a.4.4 0 00.173-.467l-1.283-3.846a5.021 5.021 0 00-5.34-3.258c-2.149.26-3.938 1.938-4.314 4.068a5.02 5.02 0 00.942 3.948c.822 1.08 1.214 2.426 1.214 3.782\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.552 22.97a.98.98 0 101.961 0 .98.98 0 00-1.961 0m-.954-3.75a.98.98 0 101.961 0 .98.98 0 00-1.961 0m0-3.751a.98.98 0 101.961 0 .98.98 0 00-1.961 0\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15.514 22.97a.98.98 0 10-1.962 0 .98.98 0 001.962 0m.954 3.752a.98.98 0 10-1.962 0 .98.98 0 001.962 0m0 3.751a.98.98 0 10-1.962 0 .98.98 0 001.962 0\" clip-rule=\"evenodd\"/><path stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M1.412 22.083l2.44-4.584a4.485 4.485 0 013.958-2.377h2.941\"/></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-icon-chiropractic';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsIconChiropractic;
}(_CustomElement);

export { DlsIconChiropractic as default };
DlsIconChiropractic.define();